export function encodeAttendeeIdForUrl(attendeeId) {
  const normalized = String(attendeeId || "").trim().toLowerCase();
  if (!normalized) {
    return "";
  }

  const bytes = new TextEncoder().encode(normalized);
  let binary = "";
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });

  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
}

function safeDecodeURIComponent(value) {
  try {
    return decodeURIComponent(value);
  } catch {
    return String(value || "");
  }
}

export function decodeAttendeeIdFromUrl(value) {
  const raw = String(value || "").trim();
  if (!raw) {
    return "";
  }

  const decodedRaw = safeDecodeURIComponent(raw).trim().toLowerCase();
  if (decodedRaw.includes("@")) {
    return decodedRaw;
  }

  try {
    const base64 = raw.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    const binary = atob(padded);
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    const decoded = new TextDecoder().decode(bytes).trim().toLowerCase();
    if (decoded.includes("@")) {
      return decoded;
    }
  } catch {
    // fall through to legacy decoding
  }

  return decodedRaw;
}

export function requiresMeetingLogin(searchParams) {
  return searchParams?.get("require_login") === "1";
}

export function buildMeetingRegisterSearchParams({ meetingId, attendeeId, requireLogin = false }) {
  const params = { meeting_id: meetingId };
  if (requireLogin) {
    params.require_login = "1";
    return params;
  }

  const encodedAttendeeId = encodeAttendeeIdForUrl(attendeeId);
  if (encodedAttendeeId) {
    params.attendee_id = encodedAttendeeId;
  }
  return params;
}

export function buildMeetingRegisterPath({ meetingId, attendeeId, requireLogin = false }) {
  const params = buildMeetingRegisterSearchParams({ meetingId, attendeeId, requireLogin });
  const query = new URLSearchParams(params).toString();
  return `/meeting/register?${query}`;
}

export function buildMeetingRegisterLocation({ meetingId, attendeeId, requireLogin = false }) {
  const params = buildMeetingRegisterSearchParams({ meetingId, attendeeId, requireLogin });
  return {
    pathname: "/meeting/register",
    search: `?${new URLSearchParams(params).toString()}`,
  };
}

export function readAttendeeIdFromLocation(location) {
  const search = String(location?.search || "");
  if (!search) {
    return "";
  }

  const params = new URLSearchParams(search);
  const attendeeParam = decodeAttendeeIdFromUrl(params.get("attendee_id"));
  if (attendeeParam) {
    return attendeeParam;
  }

  const emailParam = decodeAttendeeIdFromUrl(params.get("email"));
  if (emailParam) {
    return emailParam;
  }

  const rawMatch = search.match(/[?&](?:attendee_id|email)=([^&]*)/i);
  if (rawMatch?.[1]) {
    const legacyValue = decodeAttendeeIdFromUrl(rawMatch[1]);
    if (legacyValue) {
      return legacyValue;
    }
  }

  return "";
}
